import { Capacitor } from '@capacitor/core';
import { initializeApp, getApp, FirebaseOptions } from 'firebase/app';
import { initializeAuth, getAuth, indexedDBLocalPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage, ref, deleteObject } from 'firebase/storage';

// Your Firebase config
const firebaseConfig: FirebaseOptions = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyAeCb7WSFLzISLhHJYxXPLapzSW4oSOTis",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "activity-stream-d29c5.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "activity-stream-d29c5",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "activity-stream-d29c5.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "645726731459",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:645726731459:web:832d548c2e2723820a3676"
};

// Initialize Firebase only if it hasn't been initialized yet
let app;
try {
  app = initializeApp(firebaseConfig);
} catch (error: any) {
  if (error.code !== 'app/duplicate-app') {
    console.error('Firebase initialization error:', error);
    throw error;
  }
  app = getApp();
}

// Here's the important part:
let auth;
if (Capacitor.isNativePlatform()) {
  auth = initializeAuth(app, {
    persistence: indexedDBLocalPersistence
  });
} else {
  auth = getAuth(app);
}

const db = getFirestore(app);
const storage = getStorage(app);

export { auth, db, storage, ref, deleteObject };
